(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .factory('StrokesGained', StrokesGained);

    StrokesGained.$inject = ['$resource', app.modules.common.constants.appsettings];
    function StrokesGained($resource, ggSettings) {
        var queryUrl = ggSettings.grpapi.root + 'strokesGained',
            url = queryUrl + "(type=':type',distance=:distance)";

        return $resource(url, { type: '@type', distance: '@distance' }, {
            query: { url: queryUrl, isArray: true, method: 'GET' },
            get: { url: url, method: 'GET' }
        });
    }
})();